import { Columns } from '@shared/interfaces/table/column-config';
import {
  dashboardConsumptionNonMappedQuadrant,
  dashboardMappedQuadrant,
  dashboardMeteringPointAddressPartial,
  dashboardMeteringPointIdentificationPartial,
  dashboardMeteringPointTypePartial,
  dashboardMeterNumber,
  dashboardNonMappedQuadrant,
  dashboardOccurrence,
  dashboardPhysicalStatusPartial,
} from '@shared/columns/dashboard.columns';
import { DashboardQueryUnbalancedQuantityResultDto } from '@app/api/dmc';

export const unbalancedQuantityColumns: Columns<DashboardQueryUnbalancedQuantityResultDto>[] = [
  dashboardOccurrence,
  dashboardMeteringPointIdentificationPartial,
  dashboardMeteringPointTypePartial,
  dashboardMeteringPointAddressPartial,
  dashboardMappedQuadrant,
  dashboardNonMappedQuadrant,
  dashboardConsumptionNonMappedQuadrant,
  dashboardPhysicalStatusPartial,
  dashboardMeterNumber,
]
